import { useEffect, useRef, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import styles from "../Machines.module.scss";
import mystyles from "./DraggedRows.module.scss";
import { RootState } from "@store";
import { draggableHTMLID } from "@store/minersSelect/reducer";
import cn from "classnames";
import { Point } from "framer-motion";


const useControl = () => {
  const drag = useSelector((state: RootState) => state.minersSelect.dragMinersIDs);
  const self = useRef<HTMLDivElement | null>(null);
  const [pos, setPos] = useState<Point>({x: 0, y: 0});
  const [shift, setShift] = useState<Point>();
  const [mousePos, setMousePos] = useState<Point>();
  const [size, setSize] = useState<Point>({x: 0, y: 0});
  const [dragged, setDragged] = useState(false);
  const onMouseMoveRef = useRef<null | ((e: MouseEvent) => void)>(null);

  useEffect(() => {
    if (self.current) {
      if (drag?.length) {
        let minLeft = 1e10;
        let minTop = 1e10;
        let maxWidth = 0;
        let maxHeight = 0;
        for (const minerID of drag) {
          const el = document.getElementById(draggableHTMLID(minerID));
          if (el) {
            const rect = el.getBoundingClientRect();
            if (rect.left < minLeft) minLeft = rect.left;
            if (rect.top < minTop) minTop = rect.top;
            if (rect.width > maxWidth) maxWidth = rect.width;
            if (rect.height > maxHeight) maxHeight = rect.height;
            const clone = el.cloneNode(true) as HTMLElement;
            self.current.appendChild(clone);
          }
        }
        setPos({x: minLeft, y: minTop});
        setSize({x: maxWidth, y: maxHeight});
        setDragged(true);
      } else {
        self.current.innerHTML = "";
        setMousePos(undefined);
        setShift(undefined);
        setDragged(false);
      }
    }
  }, [drag]);

  const onMouseMove = useCallback((ev: MouseEvent) => {
    if (!mousePos) {
      setMousePos({x: ev.clientX, y: ev.clientY});
      setShift({x: 0, y: 0});
    } else {
      setShift({x: ev.clientX - mousePos.x, y: ev.clientY - mousePos.y});
    };
    //console.log("SELFRECT:", self.current?.getBoundingClientRect());
  }, [mousePos]);

  useEffect(() => {
    if (drag?.length) {
      if (onMouseMoveRef.current) {
        window.removeEventListener("mousemove", onMouseMoveRef.current);        
      }
      window.addEventListener("mousemove", onMouseMove);
      onMouseMoveRef.current = onMouseMove;
    } else if (onMouseMoveRef.current) {
      window.removeEventListener("mousemove", onMouseMoveRef.current);
      onMouseMoveRef.current = null;
    }
    return () => {
      if (onMouseMoveRef.current) window.removeEventListener("mousemove", onMouseMoveRef.current);
    }
  }, [drag, onMouseMove]);

  return {
    dragged,
    self,
    pos,
    shift,
    size,
  }
}

export default () => {
  const ctrl = useControl();
  return <div
    className={cn(styles.table_content, mystyles.container, {
      [mystyles.dragged]: ctrl.dragged,
    })}
    ref={ctrl.self}
    style={{
      left: ctrl.pos.x,
      top: ctrl.pos.y,
      transform: `translate(${ctrl.shift?.x || 0}px, ${ctrl.shift?.y || 0}px)`,
      minWidth: ctrl.size.x,
      minHeight: ctrl.size.y,
    }}
  >
  </div>
};